export const PERSONALIZATION_FEATURE = 'personalization';
